import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../Homescreen/Homescreen.module.css";
import { db } from "../firebase-config";
import { collection, addDoc } from "firebase/firestore";

function AddClient() {
  const [newClientCompanyName, setNewClientCompanyName] = useState("");
  const [newClientDirector, setNewClientDirector] = useState("");
  const [newPersonInCharge, setnewPersonInCharge] = useState("");
  const [newStatus, setnewStatus] = useState("");
  const [newRegistrationDate, setnewRegistrationDate] = useState("");
  const [newBusinessForm, setnewBusinessForm] = useState("");
  const [newCompanyRegNumber, setnewCompanyRegNumber] = useState("");
  const [newShareholders, setnewShareholders] = useState("");
  const [newPrincipal_activity, setnewPrincipal_activity] = useState("");
  const [newAddress, setnewAddress] = useState("");
  const [newMobile, setnewMobile] = useState("");
  const [newEmail, setnewEmail] = useState("");
  const [newNotes, setnewNotes] = useState("");
  const [newWebsite, setnewWebsite] = useState("");

  const clientsCollectionRef = collection(db, "clients");
  const navigate = useNavigate();
  const createClient = async () => {
    await addDoc(clientsCollectionRef, {
      company_name: newClientCompanyName,
      director: newClientDirector,
      person_in_charge: newPersonInCharge,
      status: newStatus,
      registration_date: newRegistrationDate,
      business_organisation_form: newBusinessForm,
      company_registration_number: newCompanyRegNumber,
      shareholders: newShareholders,
      principal_activity: newPrincipal_activity,
      address: newAddress,
      mobile: newMobile,
      email: newEmail,
      notes: newNotes,
      website: newWebsite,
    });
    navigate("/home/clients");
  };

  return (
    <div className={classes.mainscreen_display}>
      <div className={classes.details}>
        <div className={classes.details_info}>
          <h2>Add client</h2>
          <table>
            <thead>
              <tr>
                <td></td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>company name:</p>
                </td>
                <td>
                  <input
                    placeholder="add company name..."
                    onChange={(e) => {
                      setNewClientCompanyName(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>director:</p>
                </td>
                <td>
                  <input
                    placeholder="add director..."
                    onChange={(e) => {
                      setNewClientDirector(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>person in charge:</p>
                </td>
                <td>
                  <input
                    placeholder="add person in charge..."
                    onChange={(e) => {
                      setnewPersonInCharge(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>status:</p>
                </td>
                <td>
                  <input
                    placeholder="add status..."
                    onChange={(e) => {
                      setnewStatus(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>date of registration:</p>
                </td>
                <td>
                  <input
                    placeholder="add date of registration..."
                    onChange={(e) => {
                      setnewRegistrationDate(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>business organisation form:</p>
                </td>
                <td>
                  <input
                    placeholder="add business organisation form..."
                    onChange={(e) => {
                      setnewBusinessForm(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>company registration number:</p>
                </td>
                <td>
                  <input
                    placeholder="add company registration number..."
                    onChange={(e) => {
                      setnewCompanyRegNumber(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>shareholders:</p>
                </td>
                <td>
                  <input
                    placeholder="add shareholders..."
                    onChange={(e) => {
                      setnewShareholders(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>principal activity:</p>
                </td>
                <td>
                  <input
                    placeholder="add principal activity..."
                    onChange={(e) => {
                      setnewPrincipal_activity(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>address:</p>
                </td>
                <td>
                  <input
                    placeholder="add address..."
                    onChange={(e) => {
                      setnewAddress(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>mobile:</p>
                </td>
                <td>
                  <input
                    placeholder="add mobile..."
                    onChange={(e) => {
                      setnewMobile(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>email:</p>
                </td>
                <td>
                  <input
                    placeholder="add email..."
                    onChange={(e) => {
                      setnewEmail(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>website:</p>
                </td>
                <td>
                  <input
                    placeholder="add website..."
                    onChange={(e) => {
                      setnewWebsite(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>
                  <p>notes:</p>
                </td>
                <td>
                  <input
                    placeholder="add notes..."
                    onChange={(e) => {
                      setnewNotes(e.target.value);
                    }}
                  ></input>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button onClick={createClient}>Create Client</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AddClient;
